import React from 'react';

const PromoBanner = () => {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 overflow-hidden bg-gradient-to-r from-purple-600 via-blue-600 to-purple-600 text-white py-2 shadow-sm">
      {/* Moving banner content */}
      <div className="animate-marquee whitespace-nowrap flex items-center">
        <span className="text-sm font-medium mx-8">
          🎁 [Limited time!] Special Offer: Get 20% off any course or bundle - Use code OFFER20
        </span>
        <span className="text-sm font-medium mx-8">
          👩‍🎓 Join our 5000+ students learning cloud
        </span>
        <span className="text-sm font-medium mx-8">
          🎁 [Limited time!] Special Offer: Get 20% off any course or bundle - Use code OFFER20
        </span>
      </div>
    </div>
  );
};

export default PromoBanner;